import {
  Component,
  OnInit
} from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { BrandService } from 'src/app/api/catalog/brand.service';
import { BankService } from 'src/app/api/finance/bank.service';
import { AccountbankService } from 'src/app/api/finance/accountbank.service';
import { GeneralService } from 'src/app/api/config/general.service';

@Component({
  selector: 'app-accountbank-form',
  templateUrl: './accountbank-form.component.html',
  styleUrls: ['./accountbank-form.component.css']
})
export class AccountbankFormComponent implements OnInit {
  branchofficeSlug: string = '';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;

  // variables .......
  banks: any = [];
  typeaccounts: any = [];
  currencies: any = [];

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private globalService: GlobalService,
    private accountbankService: AccountbankService,
    private bankService: BankService,
    private generalService: GeneralService,
    private route: ActivatedRoute,
    private alertifyMsg: AlertifyHelper,
    private navigationTrackerService: NavigationTrackerService
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.route.snapshot.params['id'];
    this.item = this.fb.group({
      typeaccount_id: [null, [Validators.required]],
      bank_id: [null, [Validators.required]],
      currency_id: [null, [Validators.required]],
      branchoffice_id: [null],
      name: [null],
      number_account: [null],
      cci_account: [null],
      headline: [null],
      description: [null],
    });

    if (!_.isUndefined(this.checkId)) {
      this.txtSubmenu = environment.txt_edit_menu_form;
      this.isEdit = true;      
    }
  }

  ngOnInit() {
    this.getTypeAccount();
    this.getBanks();
    this.getCurrencies();
    this.navigationTrackerService.initializeMenu(this.route);
    if (this.isEdit) {
      this.editData();
    }
  }

  editData() {
    this.accountbankService.get(this.checkId).subscribe({
      next: (data: any) => {
        let item_ = data.data;
        this.item.patchValue({
          typeaccount_id: item_.typeaccount_id,
          bank_id: item_.bank_id,
          currency_id: item_.currency_id,
          branchoffice_id: item_.branchoffice_id,
          name: item_.name,
          number_account: item_.number_account,
          cci_account: item_.cci_account,
          headline: item_.headline,
          description: item_.description,
        });
      }
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  getTypeAccount() {
    this.accountbankService.allTypeAccount().subscribe({
      next: (data: any) => {
        this.typeaccounts = data.results;
      }
    });
  }

  getBanks() {
    this.bankService.all().subscribe({
      next: (data: any) => {
        this.banks = data.results;
      }
    });
  }

  getCurrencies() {
    this.generalService.listCurrencies().subscribe({
      next: (data: any) => {
        this.currencies = data.results;
        for (let i in this.currencies) {
          if (this.currencies[i].is_principal) {
            this.item.patchValue({
              currency_id: this.currencies[i].id
            });
          }
        }
      }
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }
    if (this.validate()) {
      if (this.isEdit) {
        this.accountbankService.update(this.checkId, this.item.value).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro actualizado con éxito');
            this.cancel();
          }
        });
      } else {
        this.accountbankService.save(this.item.value).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro realizado con éxito');
            this.cancel();
          }
        });
      }
    }
  }

  validate() {
    return true;
  }

  cancel() {
    this.router.navigate([
      this.branchofficeSlug + '/finanzas/cuentas_bancarias/lista'
    ]);
  }
}
